export default (id) => document.getElementById(id).focus();
